__turbopack_context__.v({
  "actions": "jcX7wG_actions",
  "contentCol": "jcX7wG_contentCol",
  "control": "jcX7wG_control",
  "desktopCarousel": "jcX7wG_desktopCarousel",
  "discussionActionButton": "jcX7wG_discussionActionButton",
  "engagementBar": "jcX7wG_engagementBar",
  "headerButton": "jcX7wG_headerButton",
  "mainRegion": "jcX7wG_mainRegion",
  "mobileCarousel": "jcX7wG_mobileCarousel",
  "modelBadgeText": "jcX7wG_modelBadgeText",
  "rail": "jcX7wG_rail",
  "title": "jcX7wG_title",
  "titleWrapper": "jcX7wG_titleWrapper",
  "withRail": "jcX7wG_withRail",
});
